@import '../../globals/variables';

/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  color: v(color);
}

.#{$prefix}text-wrapper {
  &.#{$prefix}info-icon-display {
    display: flex !important;
  }
}

.#{$prefix}text-info-icon {
  display: flex;
  align-items: center;
  margin: 0 16px;
  height: v(lineHeight);
}

.#{$prefix}copy {
  @include eon-typography(copy);
}

.#{$prefix}copy-link {
  @include eon-typography(copy);
  font-weight: bold !important;
  text-decoration: underline !important;
}

.#{$prefix}copy-small {
  @include eon-typography(copy-small);

  &.#{$prefix}info-icon-display {
    line-height: 1.7;

    .#{$prefix}text-info-icon {
      height: 1.7em;
    }
  }
}

.#{$prefix}quote {
  @include eon-typography(quote);
}

.#{$prefix}caption {
  @include eon-typography(caption);

  &.#{$prefix}info-icon-display {
    line-height: 1.7;

    .#{$prefix}text-info-icon {
      height: 1.7em;
    }
  }
}

.#{$prefix}abstract {
  @include eon-typography(abstract);
}

.#{$prefix}subheadline {
  @include eon-typography(subheadline);
}

.#{$prefix}rtf {
  @include eon-typography(rtf);

  &.#{$prefix}info-icon-display {
    line-height: 1.7;

    .#{$prefix}text-info-icon {
      height: 1.7em;
    }
  }
}

:host(:hover) {
  .#{$prefix}copy-link {
    color: v(hoverColor);
  }
}
